export const SET_ORDERS = "SET_ORDERS";

export const setOrders = (payload) => ({payload, type: SET_ORDERS});
